import pic1 from '../assets/pic1.jpg'
// import pic2 from '../assets/pic2.jpg'
// import pic3 from '../assets/pic3.jpg'

let getRandomInt = (min, max) => {
  return Math.floor(Math.random() * (max - min)) + min
}

export default {
  intro: {
    image: 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FoutSide%2Fbg-intro.jpg?alt=media&token=84f13400-81b0-49b6-a601-7c257690e8db',
    line1: 'High perfomance',
    line2: 'timeless styles with',
    line3: 'fashion-led activewear',
    showcaseLogo: 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2Finsta%2Fwhimm-new-logo%403x.png?alt=media&token=dc7735c7-c054-42a8-8de9-247bc432c563'
  },
  showcases: [
    { image: pic1,
      products: [
        {
          id: 1,
          productId: 89752503791,
          iconPosition: 'right',
          title: 'Amigo Circle Bag',
          x: 10,
          y: 11,
          details: {
            available: true,
            checkoutUrl: '',
            description: 'Returning to its original design, Out Side’s latest edition of running shoes utilizes the newest, lightest, and most comfortable material.',
            images: [
              `https://unsplash.it/100/?image=${getRandomInt(1, 100)}`
            ],
            price: 99,
            title: 'The Shoes'
          }
        },
        // {
        //   id: 2,
        //   productId: 8975250379,
        //   iconPosition: 'right',
        //   title: 'Amigo Circle Bag',
        //   x: 10,
        //   y: 11,
        //   details: {
        //     available: true,
        //     checkoutUrl: '',
        //     description: 'Returning to its original design, Out Side’s latest edition of running shoes utilizes the newest, lightest, and most comfortable material.',
        //     images: [
        //       `https://unsplash.it/100/?image=${getRandomInt(1, 100)}`
        //     ],
        //     price: 99,
        //     title: 'The Jacket'
        //   }
        // },
        // {
        //   id: 3,
        //   productId: 8975250379,
        //   iconPosition: 'right',
        //   title: 'Amigo Circle Bag',
        //   x: 10,
        //   y: 11,
        //   details: {
        //     available: true,
        //     checkoutUrl: '',
        //     description: 'Returning to its original design, Out Side’s latest edition of running shoes utilizes the newest, lightest, and most comfortable material.',
        //     images: [
        //       `https://unsplash.it/100/?image=${getRandomInt(1, 100)}`
        //     ],
        //     price: 99,
        //     title: 'The Jacket'
        //   }
        // },
        // {
        //   id: 4,
        //   productId: 8975250379,
        //   iconPosition: 'right',
        //   title: 'Amigo Circle Bag',
        //   x: 10,
        //   y: 11,
        //   details: {
        //     available: true,
        //     checkoutUrl: '',
        //     description: 'Returning to its original design, Out Side’s latest edition of running shoes utilizes the newest, lightest, and most comfortable material.',
        //     images: [
        //       `https://unsplash.it/100/?image=${getRandomInt(1, 100)}`
        //     ],
        //     price: 99,
        //     title: 'Amigo Circle Bag'
        //   }
        // },
        {
          id: 5,
          productId: 89752503792,
          iconPosition: 'right',
          title: 'Amigo Circle Bag',
          x: 10,
          y: 11,
          details: {
            available: true,
            checkoutUrl: '',
            description: 'Returning to its original design, Out Side’s latest edition of running shoes utilizes the newest, lightest, and most comfortable material.',
            images: [
              `https://unsplash.it/100/?image=${getRandomInt(1, 100)}`
            ],
            price: 99,
            title: 'Skinny Jeans'
          }
        },
      ]
    },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}`,
      products: [
        {
          id: 11,
          productId: 89752503793,
          iconPosition: 'right',
          title: 'Amigo Circle Bag',
          x: 10,
          y: 11,
          details: {
            available: true,
            checkoutUrl: '',
            description: 'Returning to its original design, Out Side’s latest edition of running shoes utilizes the newest, lightest, and most comfortable material.',
            images: [
              `https://unsplash.it/100/?image=${getRandomInt(1, 100)}`
            ],
            price: 99,
            title: 'The Shoes'
          }
        },
        {
          id: 2,
          productId: 89752503794,
          iconPosition: 'right',
          title: 'Amigo Circle Bag',
          x: 10,
          y: 11,
          details: {
            available: true,
            checkoutUrl: '',
            description: 'Returning to its original design, Out Side’s latest edition of running shoes utilizes the newest, lightest, and most comfortable material.',
            images: [
              `https://unsplash.it/100/?image=${getRandomInt(1, 100)}`
            ],
            price: 99,
            title: 'The Jacket'
          }
        },
        {
          id: 31,
          productId: 89752503795,
          iconPosition: 'right',
          title: 'Amigo Circle Bag',
          x: 10,
          y: 11,
          details: {
            available: true,
            checkoutUrl: '',
            description: 'Returning to its original design, Out Side’s latest edition of running shoes utilizes the newest, lightest, and most comfortable material.',
            images: [
              `https://unsplash.it/100/?image=${getRandomInt(1, 100)}`
            ],
            price: 99,
            title: 'The Jacket'
          }
        },
        {
          id: 41,
          productId: 89752503796,
          iconPosition: 'right',
          title: 'Amigo Circle Bag',
          x: 10,
          y: 11,
          details: {
            available: true,
            checkoutUrl: '',
            description: 'Returning to its original design, Out Side’s latest edition of running shoes utilizes the newest, lightest, and most comfortable material.',
            images: [
              `https://unsplash.it/100/?image=${getRandomInt(1, 100)}`
            ],
            price: 99,
            title: 'Amigo Circle Bag'
          }
        },
        {
          id: 51,
          productId: 89752503797,
          iconPosition: 'right',
          title: 'Amigo Circle Bag',
          x: 10,
          y: 11,
          details: {
            available: true,
            checkoutUrl: '',
            description: 'Returning to its original design, Out Side’s latest edition of running shoes utilizes the newest, lightest, and most comfortable material.',
            images: [
              `https://unsplash.it/100/?image=${getRandomInt(1, 100)}`
            ],
            price: 99,
            title: 'Skinny Jeans'
          }
        },
      ]
    },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}`,
      products: [
        {
          id: 12,
          productId: 89752503798,
          iconPosition: 'right',
          title: 'Amigo Circle Bag',
          x: 10,
          y: 11,
          details: {
            available: true,
            checkoutUrl: '',
            description: 'Returning to its original design, Out Side’s latest edition of running shoes utilizes the newest, lightest, and most comfortable material.',
            images: [
              `https://unsplash.it/100/?image=${getRandomInt(1, 100)}`
            ],
            price: 99,
            title: 'The Shoes'
          }
        },
        {
          id: 21,
          productId: 89752503799,
          iconPosition: 'right',
          title: 'Amigo Circle Bag',
          x: 10,
          y: 11,
          details: {
            available: true,
            checkoutUrl: '',
            description: 'Returning to its original design, Out Side’s latest edition of running shoes utilizes the newest, lightest, and most comfortable material.',
            images: [
              `https://unsplash.it/100/?image=${getRandomInt(1, 100)}`
            ],
            price: 99,
            title: 'The Jacket'
          }
        },
        {
          id: 32,
          productId: 89752503790,
          iconPosition: 'right',
          title: 'Amigo Circle Bag',
          x: 10,
          y: 11,
          details: {
            available: true,
            checkoutUrl: '',
            description: 'Returning to its original design, Out Side’s latest edition of running shoes utilizes the newest, lightest, and most comfortable material.',
            images: [
              `https://unsplash.it/100/?image=${getRandomInt(1, 100)}`
            ],
            price: 99,
            title: 'The Jacket'
          }
        },
        {
          id: 42,
          productId: 897525037911,
          iconPosition: 'right',
          title: 'Amigo Circle Bag',
          x: 10,
          y: 11,
          details: {
            available: true,
            checkoutUrl: '',
            description: 'Returning to its original design, Out Side’s latest edition of running shoes utilizes the newest, lightest, and most comfortable material.',
            images: [
              `https://unsplash.it/100/?image=${getRandomInt(1, 100)}`
            ],
            price: 99,
            title: 'Amigo Circle Bag'
          }
        },
        {
          id: 52,
          productId: 897525037912,
          iconPosition: 'right',
          title: 'Amigo Circle Bag',
          x: 10,
          y: 11,
          details: {
            available: true,
            checkoutUrl: '',
            description: 'Returning to its original design, Out Side’s latest edition of running shoes utilizes the newest, lightest, and most comfortable material.',
            images: [
              `https://unsplash.it/100/?image=${getRandomInt(1, 100)}`
            ],
            price: 99,
            title: 'Skinny Jeans'
          }
        },
      ]
    },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}`,
      products: [
        {
          id: 13,
          productId: 897525037913,
          iconPosition: 'right',
          title: 'Amigo Circle Bag',
          x: 10,
          y: 11,
          details: {
            available: true,
            checkoutUrl: '',
            description: 'Returning to its original design, Out Side’s latest edition of running shoes utilizes the newest, lightest, and most comfortable material.',
            images: [
              `https://unsplash.it/100/?image=${getRandomInt(1, 100)}`
            ],
            price: 99,
            title: 'The Shoes'
          }
        },
        {
          id: 22,
          productId: 897525037914,
          iconPosition: 'right',
          title: 'Amigo Circle Bag',
          x: 10,
          y: 11,
          details: {
            available: true,
            checkoutUrl: '',
            description: 'Returning to its original design, Out Side’s latest edition of running shoes utilizes the newest, lightest, and most comfortable material.',
            images: [
              `https://unsplash.it/100/?image=${getRandomInt(1, 100)}`
            ],
            price: 99,
            title: 'The Jacket'
          }
        },
        {
          id: 23,
          productId: 897525037915,
          iconPosition: 'right',
          title: 'Amigo Circle Bag',
          x: 10,
          y: 11,
          details: {
            available: true,
            checkoutUrl: '',
            description: 'Returning to its original design, Out Side’s latest edition of running shoes utilizes the newest, lightest, and most comfortable material.',
            images: [
              `https://unsplash.it/100/?image=${getRandomInt(1, 100)}`
            ],
            price: 99,
            title: 'The Jacket'
          }
        },
        {
          id: 24,
          productId: 897525037916,
          iconPosition: 'right',
          title: 'Amigo Circle Bag',
          x: 10,
          y: 11,
          details: {
            available: true,
            checkoutUrl: '',
            description: 'Returning to its original design, Out Side’s latest edition of running shoes utilizes the newest, lightest, and most comfortable material.',
            images: [
              `https://unsplash.it/100/?image=${getRandomInt(1, 100)}`
            ],
            price: 99,
            title: 'Amigo Circle Bag'
          }
        },
        {
          id: 25,
          productId: 897525037917,
          iconPosition: 'right',
          title: 'Amigo Circle Bag',
          x: 10,
          y: 11,
          details: {
            available: true,
            checkoutUrl: '',
            description: 'Returning to its original design, Out Side’s latest edition of running shoes utilizes the newest, lightest, and most comfortable material.',
            images: [
              `https://unsplash.it/100/?image=${getRandomInt(1, 100)}`
            ],
            price: 99,
            title: 'Skinny Jeans'
          }
        },
      ]
    },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}`,
      products: [
        {
          id: 14,
          productId: 897525037918,
          iconPosition: 'right',
          title: 'Amigo Circle Bag',
          x: 10,
          y: 11,
          details: {
            available: true,
            checkoutUrl: '',
            description: 'Returning to its original design, Out Side’s latest edition of running shoes utilizes the newest, lightest, and most comfortable material.',
            images: [
              `https://unsplash.it/100/?image=${getRandomInt(1, 100)}`
            ],
            price: 99,
            title: 'The Shoes'
          }
        },
        {
          id: 26,
          productId: 897525037919,
          iconPosition: 'right',
          title: 'Amigo Circle Bag',
          x: 10,
          y: 11,
          details: {
            available: true,
            checkoutUrl: '',
            description: 'Returning to its original design, Out Side’s latest edition of running shoes utilizes the newest, lightest, and most comfortable material.',
            images: [
              `https://unsplash.it/100/?image=${getRandomInt(1, 100)}`
            ],
            price: 99,
            title: 'The Jacket'
          }
        },
        {
          id: 27,
          productId: 897525037920,
          iconPosition: 'right',
          title: 'Amigo Circle Bag',
          x: 10,
          y: 11,
          details: {
            available: true,
            checkoutUrl: '',
            description: 'Returning to its original design, Out Side’s latest edition of running shoes utilizes the newest, lightest, and most comfortable material.',
            images: [
              `https://unsplash.it/100/?image=${getRandomInt(1, 100)}`
            ],
            price: 99,
            title: 'The Jacket'
          }
        },
        {
          id: 33,
          productId: 897525037921,
          iconPosition: 'right',
          title: 'Amigo Circle Bag',
          x: 10,
          y: 11,
          details: {
            available: true,
            checkoutUrl: '',
            description: 'Returning to its original design, Out Side’s latest edition of running shoes utilizes the newest, lightest, and most comfortable material.',
            images: [
              `https://unsplash.it/100/?image=${getRandomInt(1, 100)}`
            ],
            price: 99,
            title: 'Amigo Circle Bag'
          }
        },
        {
          id: 43,
          productId: 897525037922,
          iconPosition: 'right',
          title: 'Amigo Circle Bag',
          x: 10,
          y: 11,
          details: {
            available: true,
            checkoutUrl: '',
            description: 'Returning to its original design, Out Side’s latest edition of running shoes utilizes the newest, lightest, and most comfortable material.',
            images: [
              `https://unsplash.it/100/?image=${getRandomInt(1, 100)}`
            ],
            price: 99,
            title: 'Skinny Jeans'
          }
        },
      ]
    },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}`,
      products: [
        {
          id: 15,
          productId: 897525037923,
          iconPosition: 'right',
          title: 'Amigo Circle Bag',
          x: 10,
          y: 11,
          details: {
            available: true,
            checkoutUrl: '',
            description: 'Returning to its original design, Out Side’s latest edition of running shoes utilizes the newest, lightest, and most comfortable material.',
            images: [
              `https://unsplash.it/100/?image=${getRandomInt(1, 100)}`
            ],
            price: 99,
            title: 'The Shoes'
          }
        },
        {
          id: 28,
          productId: 897525037924,
          iconPosition: 'right',
          title: 'Amigo Circle Bag',
          x: 10,
          y: 11,
          details: {
            available: true,
            checkoutUrl: '',
            description: 'Returning to its original design, Out Side’s latest edition of running shoes utilizes the newest, lightest, and most comfortable material.',
            images: [
              `https://unsplash.it/100/?image=${getRandomInt(1, 100)}`
            ],
            price: 99,
            title: 'The Jacket'
          }
        },
        {
          id: 34,
          productId: 897525037925,
          iconPosition: 'right',
          title: 'Amigo Circle Bag',
          x: 10,
          y: 11,
          details: {
            available: true,
            checkoutUrl: '',
            description: 'Returning to its original design, Out Side’s latest edition of running shoes utilizes the newest, lightest, and most comfortable material.',
            images: [
              `https://unsplash.it/100/?image=${getRandomInt(1, 100)}`
            ],
            price: 99,
            title: 'The Jacket'
          }
        },
        {
          id: 44,
          productId: 897525037926,
          iconPosition: 'right',
          title: 'Amigo Circle Bag',
          x: 10,
          y: 11,
          details: {
            available: true,
            checkoutUrl: '',
            description: 'Returning to its original design, Out Side’s latest edition of running shoes utilizes the newest, lightest, and most comfortable material.',
            images: [
              `https://unsplash.it/100/?image=${getRandomInt(1, 100)}`
            ],
            price: 99,
            title: 'Amigo Circle Bag'
          }
        },
        {
          id: 53,
          productId: 897525037927,
          iconPosition: 'right',
          title: 'Amigo Circle Bag',
          x: 10,
          y: 11,
          details: {
            available: true,
            checkoutUrl: '',
            description: 'Returning to its original design, Out Side’s latest edition of running shoes utilizes the newest, lightest, and most comfortable material.',
            images: [
              `https://unsplash.it/100/?image=${getRandomInt(1, 100)}`
            ],
            price: 99,
            title: 'Skinny Jeans'
          }
        },
      ]
    },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },
    { image: `https://unsplash.it/100/?image=${getRandomInt(1, 100)}` },


  ],
  appSettings: {
    title: 'Instant App',
    integration: null,
    googleAnalyticsId: null,
    overrideArrays: true, // this is used in applyCosomField function for merging data
    columns: 3
  }
}



// WEBPACK FOOTER //
// ./src/templates/insta/template/settings.js